import React from "react";
import { FaSearch } from "react-icons/fa";
import { doctorDisplayName, formatConversationTime, initials } from "../../utils/consultationChatFormat";
import LoadingState from "../States/LoadingState";

const ConversationSidebar = ({
  conversations,
  selectedConversationId,
  onSelect,
  search,
  onSearchChange,
  loading,
  error,
}) => (
  <aside className="flex flex-col h-full min-h-0 border-r border-surface-container bg-surface-lowest">
    <div className="px-4 pt-4 pb-3 border-b border-surface-container shrink-0">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-semibold text-on-primary-fixed-var">Conversations</h2>
        <span className="text-xs font-medium text-primary">Active Care</span>
      </div>
      <div className="relative">
        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant" size={14} />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search messages or doctors..."
          className="w-full pl-9 pr-3 py-2.5 text-sm rounded-full border border-surface-container bg-surface-low focus:outline-none focus:ring-2 focus:ring-primary/30"
        />
      </div>
    </div>

    <div className="flex-1 overflow-y-auto min-h-0">
      {loading ? (
        <LoadingState branded brandedCompact message="Loading conversations…" className="py-8" />
      ) : error ? (
        <p className="text-sm text-error text-center py-8 px-4">{error}</p>
      ) : conversations.length === 0 ? (
        <p className="text-sm text-on-surface-variant text-center py-8 px-4">No conversations yet.</p>
      ) : (
        <ul className="py-1">
          {conversations.map(({ doctor, snippet, lastMessageAt }) => {
            const active = selectedConversationId === doctor._id;
            return (
              <li key={doctor._id}>
                <button
                  type="button"
                  onClick={() => onSelect(doctor)}
                  className={`w-full text-left px-4 py-3 flex gap-3 transition-colors border-l-4 ${
                    active
                      ? "border-primary bg-primary-fixed/25"
                      : "border-transparent hover:bg-surface-low"
                  }`}
                >
                  <div className="relative shrink-0">
                    {doctor.image ? (
                      <img
                        src={doctor.image}
                        alt=""
                        className="w-11 h-11 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-11 h-11 rounded-full bg-primary flex items-center justify-center text-white text-sm font-bold">
                        {initials(doctor.name)}
                      </div>
                    )}
                    <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-green-500 border-2 border-surface-lowest" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-baseline justify-between gap-2">
                      <p className="font-semibold text-sm text-on-primary-fixed-var truncate">
                        {doctorDisplayName(doctor)}
                      </p>
                      <span className="text-[10px] text-on-surface-variant shrink-0">
                        {formatConversationTime(lastMessageAt)}
                      </span>
                    </div>
                    <p className="text-xs text-on-surface-variant truncate">{doctor.specialization || "General Physician"}</p>
                    <p className="text-xs text-on-surface-variant mt-0.5 line-clamp-1">{snippet}</p>
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  </aside>
);

export default ConversationSidebar;
